module.exports = __webpack_public_path__ + "img/icon-cashondelivery.f8ded133.svg";